export default "__VITE_ASSET__gcb9OGcZuPgUxyaFwWeVIw__"